import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const compareBenefits = benefitIds =>
  call(websocketFetch, 'compare_benefits', {
    benefits: benefitIds,
  });
